module.exports = __webpack_public_path__ + "assets/img/14_930_big.ce2ba04b.jpg";